module.exports = function getResource(label, vars = []) {
    let resources = {
        editProfile: 'Edit Profile',
        profileCategories: [
            'Photos & Bio',
            'Skin',
            'Hair',
            'Eyes',
            'Color IQ',
            'Birthday',
            'Privacy'
        ]
    };
    return resources[label];
};
